<template>
  <div class="dynamic-field-container">
    <label>{{ field.label }}</label>
    <el-select
      data-vv-validate-on="change"
      :name="fieldName"
      :data-vv-as="fieldName"
      class="fifty-percent"
      v-model="proxyValue"
      v-validate="fieldValidationRules"
      :placeholder="field.placeholder"
      :disabled="isTaskFieldDisabled"
      :value="field.value">
      <el-option v-for="option in sortedFieldValues"
                 class="select"
                 :value="option.value"
                 :label="option.label"
                 :key="option.label" />
    </el-select>
    <small class="text-danger" v-show="errors.has(fieldName)" style="display: block; margin-top: 7px;">
      {{ getError(fieldName) }}
    </small>
  </div>
</template>

<script>
  import {generateDynamicFieldValidation, canEditTaskField, sortBySort} from 'src/utilities/utils'

  export default {
    inject: ['$validator'],
    props: ['field', 'value', 'commit', 'task', 'disabled'],
    fieldName: 'temp',
    computed: {
      sortedFieldValues() {
        return sortBySort(this.field.values)
      },
      fieldValidationRules() {
        // expressions override other validation logic
        if (this.field.expression) {
          this.fieldValidation = function(str) {
            return eval(str).apply(this)
          }.call(this, this.field.expression)
        }
        return this.fieldValidation
      },
      proxyValue: {
        get() {
          return this.value
        },
        set(newValue) {
          this.$store.commit(this.commit, { key: this.field.key, value: newValue })
        }
      },
      isTaskFieldDisabled() {
        if (this.disabled) {
          return true
        }
        return !canEditTaskField(this)
      }
    },
    data() {
      return {
        fieldValidation: {},
        statusOnLoad: null
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeMount() {
      generateDynamicFieldValidation(this)
      this.statusOnLoad = JSON.parse(JSON.stringify(this.task.status))
    }
  }
</script>

<style scoped>
  label {
    display: block;
  }
  .dynamic-field-container {
    margin-bottom: 10px;
  }
  .fifty-percent {
    width: 50%
  }
</style>
